// extracted by mini-css-extract-plugin
export default {"addFavouritesView":"AddFavourites_addFavouritesView__zPDob"};